import React, { Component } from "react";
import { Link } from "react-router-dom";
import * as Connection from "./../libs/connections";

import Preloader from "./../components/global/Preloader";
import HeroBannerSmall from "./../components/HeroBannerSmall";
import CarsList from "./../components/CarsList";
import ShowroomFullScreen from "../components/ShowroomFullScreen";

import "../styles/sites/CarFleetPage.css";

import showroomBackground from "../assets/backgrounds/fleet-contact.jpg";

export default class CarFleetPage extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      error: false,
      HeroBannerSmall: {},
      filters: {
        carRental: [],
        carType: [],
        carBrand: [],
        carBody: [],
        carYearFrom: [],
        carYearTo: [],
        carPowerFrom: [],
        carPowerTo: [],
        carEngineCapacityFrom: [],
        carEngineCapacityTo: [],
        carGear: []
      }
    };
  }

  async componentDidMount() {
    try {
      const response = await Connection.getPageBySlug("flota");
      this.setState({
        loading: false,
        heroBannerSmall: response.acf.HeroBannerSmall,
        title: response.title.rendered,
        bannerShowRoom: response.acf.showroom
      });
    } catch (err) {
      this.setState({
        error: true
      });
    }
  }

  render() {
    return (
      <div className="page-car-fleet">
        <Preloader global loading={this.state.loading} />
        {this.state.heroBannerSmall && (
          <HeroBannerSmall
            center
            fromTop
            backgroundImage={this.state.heroBannerSmall}
            smallContainer={true}
            headerText={this.state.title}
          />
        )}
        {this.state.filters && <CarsList filters={this.state.filters} />}
        <ShowroomFullScreen
          backgroundImage={showroomBackground}
          classes={`container container-small`}
          text={
            <div className="row">
              <div className="showroom-text col-12">
                <div className="" style={{ color: "black" }}>
                  <p style={{ marginBottom: "0" }}>
                    Są inne pojazdy, które chcesz wynająć?
                  </p>
                  <p style={{ marginBottom: "60px" }}>Daj nam znać.</p>
                  <Link
                    className="btn-general btn-general--primary btn-general--noBackground"
                    to="/kontakt"
                  >
                    Kontakt
                  </Link>
                </div>
              </div>
            </div>
          }
        />
      </div>
    );
  }
}
